var _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 12.5,
    fill: "white",
    stroke: "#FA9418"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(90 27 21)",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqRemove);
export default __webpack_public_path__ + "static/media/faq-remove.c8855a461d51f23c41bdfd612ae9b485.svg";
export { ForwardRef as ReactComponent };